import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { TextFieldUI } from '@axo/form/feature/form-input/TextField/TextFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { useFormContext } from 'react-hook-form';
import {
  getAgeFromFinnishSSN,
  getGenderFromFinnishSSN,
} from '../../../../../utils/Finland/validateFinnishSSN';
import { Step2Data } from '../../../FormData.fi.types';
import { radioOptions } from '../../config/globals';
import { gridColumns } from '../../config/layouts/grid';
import { socialSecurityNumberFieldOptions } from '../shared-config';
import { militaryServiceCompletedFieldOptions } from './config';

const onBlurCapture = (e: React.FocusEvent<HTMLInputElement>) => {
  e.target.type = 'password';
};

const onFocusCapture = (e: React.FocusEvent<HTMLInputElement>) => {
  e.target.type = 'text';
};

export const PersonFormGroup = () => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const ssn = watch('Person/SocialSecurityNumber');
  const age = getAgeFromFinnishSSN(ssn);
  const askMilitaryService =
    age && age < 30 && getGenderFromFinnishSSN(ssn) === 'male';

  return (
    <Grid columns={gridColumns}>
      <TextFieldUI<Step2Data>
        name="Person/SocialSecurityNumber"
        label={t('SocialSecurityNumber.label')}
        data-testid="ssn-input"
        onBlurCapture={onBlurCapture}
        onFocusCapture={onFocusCapture}
        {...socialSecurityNumberFieldOptions}
      />

      {askMilitaryService && (
        <RadioFieldUI<Step2Data>
          name="LoanApplication/MilitaryServiceCompleted"
          label={t('MilitaryServiceCompleted.label')}
          data-testid="military-service-completed-input"
          options={radioOptions}
          radioStyle="both"
          {...militaryServiceCompletedFieldOptions}
        />
      )}
    </Grid>
  );
};
